const cancerTypesRequiringCancerWord = new Set([
  'colon',
  'lung',
  'prostate',
  'breast',
  'pancreatic',
  'stomach',
  'liver',
  'cervical',
  'thyroid',
  'esophageal',
  'bladder',
  'ovarian',
  'kidney',
  'brain',
  'testicular',
  'head_and_neck',
  'endometrial',
  'overall',
]);
export function getCancerRiskSuffix(cancerType: string): string {
  return cancerTypesRequiringCancerWord.has(cancerType) ? ' cancer' : '';
}
